<owc-table>
    
    <owc-table-header sticky style="z-index:1; border-bottom: none !important; box-shadow: none !important;">
      <owc-table-header-cell  [align]="'left'">
        Date
      </owc-table-header-cell>
  
      <owc-table-header-cell  [align]="'left'">
        Subject
      </owc-table-header-cell>
  
      <owc-table-header-cell  [align]="'left'">
        Message
      </owc-table-header-cell>
  
      <owc-table-header-cell  [align]="'left'">
        Send mode
      </owc-table-header-cell>
  
      <owc-table-header-cell [align]="'center'">
        Actions
      </owc-table-header-cell>
    </owc-table-header>
  
    <owc-table-body>
      @for (element of tableData; track $index) {
        <owc-table-row>
        
          <owc-table-simple-cell [title]="element.reminderDate">
            <div class="truncate-text">{{ element?.reminderDate }}</div>
          </owc-table-simple-cell>
  
        
          <owc-table-simple-cell [title]="element.reminderSubject">
            <div class="truncate-text">{{ element?.reminderSubject }}</div>
          </owc-table-simple-cell>
  
         
          <owc-table-simple-cell>
            <div class="truncate-text" [innerHTML]="element?.reminderMessage"></div>
          </owc-table-simple-cell>
  
         
          <owc-table-simple-cell>
            <div class="truncate-text">
              {{ element.reminderSendMode === '0' ? 'Automatic' : 'Manual' }}
            </div>
          </owc-table-simple-cell>
  
          
          <owc-table-simple-cell>
            <div class="icon-actions">
                <i class="one-icons-outlined action-icon" 
                   [class.disabled]="isReminderDatePast(element.reminderDate)"
                   (click)="!isReminderDatePast(element.reminderDate) && editReminderTemplate(element, $index)"> write </i>
                <i class="one-icons-outlined action-icon" 
                   [class.disabled]="isReminderDatePast(element.reminderDate)"
                   (click)="!isReminderDatePast(element.reminderDate) && deleteReminderTemplate(element, $index)"> delete </i>
            </div>
            <owc-modal-dialog #modalDialogElement [(ngModel)]="editVisible" size="medium">
              <dl-create-reminder [data]="data" 
              (dialogClose)="onDialogClose($event)"></dl-create-reminder>
           </owc-modal-dialog>
          </owc-table-simple-cell>
        </owc-table-row>
      }
    </owc-table-body>
  </owc-table>